module.exports = __webpack_public_path__ + "img/2.2.038f4b1d.jpg";